module.exports = __webpack_public_path__ + "img/ravio_logo.580e74b2.svg";